import { useState } from "react";
import Calendar from "react-calendar";
import { useForm } from "../../../hooks";
import { useDailyAssessmentStore, usePatientSurgeryStore } from "../../hooks";

const months = [
  "Ene",
  "Feb",
  "Mar",
  "Abr",
  "May",
  "Jun",
  "Jul",
  "Ago",
  "Sep",
  "Oct",
  "Nov",
  "Dic",
];

const years = Array.from(
  { length: 10 },
  (_, i) => new Date().getFullYear() - 5 + i,
);

const formValidations = {};

export const DashboardCalendar = () => {
  // Datos del hook ----------------------------------------//
  const {
    // Props
    filters,

    // Methods
    startChangeDate,
  } = useDailyAssessmentStore();

  const {
    getPatientSurgery,
    pagination,
    filters: patientSurgeryFilters,
  } = usePatientSurgeryStore();

  // States ------------------------------------------------//
  const [formData, setFormData] = useState(filters);
  const [date, setDate] = useState(new Date());
  const [activeStartDate, setActiveStartDate] = useState(new Date());
  const [view, setView] = useState("month");

  // Formulario --------------------------------------------//
  const { formState, onInputChange, onResetForm } = useForm(
    formData,
    formValidations,
  );

  // Funciones ---------------------------------------------//
  const handleMonthChange = (e) => {
    const newDate = new Date(activeStartDate);
    newDate.setMonth(Number(e.target.value));
    setActiveStartDate(newDate);
  };

  const handleYearChange = (e) => {
    const newDate = new Date(activeStartDate);
    newDate.setFullYear(Number(e.target.value));
    setActiveStartDate(newDate);
  };

  const handleDateChange = (newDate) => {
    setDate(newDate);
    const date = newDate.toISOString();
    const updatedFormData = {
      ...formState,
      date,
    };

    setFormData(updatedFormData);

    startChangeDate(updatedFormData);

    getPatientSurgery({ filters: patientSurgeryFilters, pagination, date });
  };

  // Efectos -----------------------------------------------//

  return (
    <div className="card shadow-md">
      <div className="card-body">
        <div className="d-flex flex-wrap justify-content-end gap-2 mb-2">
          {view === "month" && (
            <select
              className="form-select w-auto"
              value={activeStartDate.getMonth()}
              onChange={handleMonthChange}
            >
              {months.map((month, idx) => (
                <option key={month} value={idx}>
                  {month}
                </option>
              ))}
            </select>
          )}

          <select
            className="form-select w-auto"
            value={activeStartDate.getFullYear()}
            onChange={handleYearChange}
          >
            {years.map((year) => (
              <option key={year} value={year}>
                {year}
              </option>
            ))}
          </select>

          <div className="btn-group" role="group" aria-label="View toggle">
            <button
              type="button"
              className={`btn btn-outline-primary ${
                view === "month" ? "active" : ""
              }`}
              onClick={() => setView("month")}
            >
              Mes
            </button>
            <button
              type="button"
              className={`btn btn-outline-primary ${
                view === "year" ? "active" : ""
              }`}
              onClick={() => setView("year")}
            >
              Año
            </button>
          </div>
        </div>
        <Calendar
          className={"w-100 border-0"}
          onChange={handleDateChange}
          value={date}
          view={view}
          onViewChange={({ view }) => setView(view)}
          activeStartDate={activeStartDate}
          onActiveStartDateChange={({ activeStartDate }) =>
            setActiveStartDate(activeStartDate)
          }
          locale="es-ES"
          showNavigation={false}
        />
      </div>
    </div>
  );
};
